import type { ReactNode } from "react";

import type { RiskTierCounts } from "@busright/data-contract";
import { RAG } from "@busright/ui";

import { formatInt } from "@/lib/format";

export interface CustomerHealthChipProps {
  // Null when the customer never matched a warehouse district (no device-health join).
  readonly riskCounts: RiskTierCounts | null;
}

// Compact OK / WARN / CRIT triple for a matched customer's device fleet. RAG color is allowed here
// because each count maps directly to a device risk tier (the one place RAG is reserved for).
export const CustomerHealthChip = ({ riskCounts }: CustomerHealthChipProps): ReactNode => {
  if (!riskCounts) {
    return <span className="mono">—</span>;
  }
  return (
    <span style={{ display: "inline-flex", gap: 10 }}>
      <span className="mono br-tabular-nums" style={{ color: RAG.OK }} title="OK devices">
        {formatInt(riskCounts.ok)}
      </span>
      <span className="mono br-tabular-nums" style={{ color: RAG.WARN }} title="WARN devices">
        {formatInt(riskCounts.warn)}
      </span>
      <span
        className="mono br-tabular-nums"
        style={{ color: RAG.CRITICAL }}
        title="CRITICAL devices"
      >
        {formatInt(riskCounts.critical)}
      </span>
    </span>
  );
};
